<template>
  <span class="item-name">
    <span class="icon is-small toc-item-icon">
      <i v-show="item.children"
          :class="[props.open ? 'fa-angle-down' : 'fa-angle-right', hasChildrenHighlighted(item) ? 'has-text-info' :'']"
          class="fa fa-fw open-icon"
          @click.stop.prevent="emit('toggle')"/>
    </span>
    <span class="toc-item-text">
      <span v-if="props.highlightedNameHtml" class="toc-item-highlight" v-html="props.highlightedNameHtml" />
      <span v-else>
        {{ item.name }}
      </span>
      <span v-if="props.helpTextHtml" class="help-text toc-item-highlight" v-html="props.helpTextHtml" />
      <span v-else-if="props.helpText" class="help-text">{{ props.helpText }}</span>
    </span>
  </span>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    default: () => {}
  },
  highlighted: {
    type: Array,
    default: () => []
  },
  highlightedNameHtml: {
    type: String,
    default: null
  },
  helpText: {
    type: String,
    default: null
  },
  helpTextHtml: {
    type: String,
    default: null
  },
  open: Boolean
})

const emit = defineEmits(['toggle'])

function hasChildrenHighlighted(parent) {
  return parent?.children?.some(child => {
    return props.highlighted.some(tocItem => {
      return (tocItem?.entityId === child.id)
        && (tocItem?.entityType === child.type)
    }) || hasChildrenHighlighted(child)
  }) ?? false
}
</script>

<style lang="scss" scoped>
.item-name {
  white-space: nowrap;
  display: flex;
  align-items: flex-start;
}

.toc-item-icon {
  flex: 0 0 auto;
}

.toc-item-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.toc-item-highlight :deep(.highlightText) {
  text-decoration: underline;
}

.help-text {
  display: block;
  font-style: oblique;
  font-size: small;
}
</style>
